export const INTERNAL_WIDTH = 384;
export const INTERNAL_HEIGHT = 216;
export const FIXED_HZ = 60;
export const FIXED_DT = 1 / FIXED_HZ;
export const FIXED_DT_MS = 1000 / FIXED_HZ;
export const MAX_CATCH_UP_STEPS = 3;
export const MAX_FRAME_DELTA_MS = FIXED_DT_MS * MAX_CATCH_UP_STEPS;
export const HUD_PUBLISH_INTERVAL_TICKS = 6;

export const POOL_CAPACITY = Object.freeze({
  player: 1,
  nodes: 3,
  enemies: 256,
  projectiles: 768,
  particles: 1024,
  pickups: 96,
  bossParts: 32,
  backgroundObjects: 256,
  dynamicSprites: 1800,
});

export const enum GameMode {
  Boot = 0,
  Title = 1,
  Controls = 2,
  Playing = 3,
  CalibrationGate = 4,
  Paused = 5,
  StageResult = 6,
  GameOver = 7,
  Ending = 8,
  Error = 9,
}

export const enum DifficultyId {
  Calm = 0,
  Bright = 1,
  Fracture = 2,
}

export const enum Owner {
  Player = 0,
  Enemy = 1,
}

export const enum ProjectileKind {
  Pulse = 0,
  Arc = 1,
  Prism = 2,
  Lattice = 3,
  Node = 4,
  EnemyOrb = 5,
  EnemyNeedle = 6,
  Laser = 7,
  Lock = 8,
  Reflected = 9,
  Phase = 10,
}

export const enum ProjectileFlags {
  None = 0,
  Piercing = 1 << 0,
  Unblockable = 1 << 1,
  Segment = 1 << 2,
  Homing = 1 << 3,
  Reflected = 1 << 4,
}

export const enum EnemyType {
  Threadling = 0,
  PlateFin = 1,
  Indexer = 2,
  ShadePolyp = 3,
  MirrorWisp = 4,
  LockBeetle = 5,
  FoldRay = 6,
  ArchiveRam = 7,
  ChoirEngine = 8,
  PrismEater = 9,
}

export const ENEMY_TYPE_COUNT = 10;

export const enum EnemyState {
  Free = 0,
  Spawn = 1,
  Enter = 2,
  Navigate = 3,
  Aim = 4,
  Telegraph = 5,
  Attack = 6,
  Recover = 7,
  Disabled = 8,
  Dying = 9,
}

export const enum BossKind {
  None = 0,
  CatalogueMouth = 1,
  NullScribe = 2,
  MnemosyneArray = 3,
}

export const enum PickupKind {
  Lux = 0,
  Repair = 1,
  Score = 2,
  Power = 3,
}

export const WEAPON_MAX_LEVEL = 4;
export const POWER_THRESHOLDS = new Uint8Array([3, 4, 5, 6]);
/**
 * R2 continuous-arsenal thresholds, measured in directly banked SYNC rather
 * than discrete legacy Power units. Each value is the cost of the next grade,
 * not a cumulative total. The legacy route continues to use POWER_THRESHOLDS.
 */
export const SYNC_GRADE_THRESHOLDS = new Uint16Array([60, 120, 180, 240]);
export const SYNC_GRADE_TOTAL = 600;
export const SYNC_POWER_PICKUP_VALUE = 25;
export const SYNC_GATE_SURGE_VALUE = 60;
export const POWER_DROP_KILL_INTERVAL = 5;
export const BOSS_POWER_DROPS = 2;
export const POWER_OVERFLOW_SCORE = 500;

export const enum DeviceState {
  Ready = 0,
  Active = 1,
  Cooldown = 2,
}

export const enum InputAction {
  Up = 0,
  Down = 1,
  Left = 2,
  Right = 3,
  Fire = 4,
  AimLock = 5,
  Formation = 6,
  NodeDirectionLeft = 7,
  NodeDirectionRight = 8,
  Device = 9,
  Pause = 10,
  Confirm = 11,
  Cancel = 12,
}

export const INPUT_ACTION_COUNT = 13;
